import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import PageTitle from 'components/atoms/PageTitle'
import PageLoading from 'components/atoms/PageLoading'

import useSession from 'hooks/useSession'

export default function Sessions() {
  const { t } = useTranslation()

  const { isFetching, fetchCurrentSession, session } = useSession()

  useEffect(() => {
    fetchCurrentSession()
  }, [fetchCurrentSession])

  return (
    <div className="content-container">
      {isFetching || !Object.keys(session).length ? (
        <PageLoading />
      ) : session?.sessionId ? (
        <Navigate to={`/sessions/${session.sessionId}`} />
      ) : (
        <>
          <PageTitle label={t('sessions.title')} />
          {t('sessions.emptyContent')}
        </>
      )}
    </div>
  )
}
